import { Injectable } from "@angular/core";

@Injectable()
export class ApplicationService {
  constructor() {}
  createRequestTouristIndividual(
    data,
    temporary_id,
    website_url,
    ChilddataSource,
    passport_path,
    ip_address,
    BrowserDetails
  ) {
    // format data as per backend requirement
    return {
      temporary_id: temporary_id == null ? "" : temporary_id,
      application_type: "Tourist Individual",
      visa_type:
        "Normal Processing (Visa Delivery Time 24 to 48 Business Hours)", //data.visa_type,
      surname_family_name: data.surname_family_name,
      other_given_name: data.other_given_name,
      title: data.title,
      dob:
        data.dob == null
          ? ""
          : data.dob.day + "/" + data.dob.month + "/" + data.dob.year,
      gender: data.gender,
      nationality: data.nationality,
      isVaccinated: data.isVaccinated,
      country_of_birth: data.country_of_birth,
      occupation: data.occupation,
      passport_no: data.passport_no,
      passport_issue_date:
        data.passport_issue_date == null
          ? ""
          : data.passport_issue_date.day +
            "/" +
            data.passport_issue_date.month +
            "/" +
            data.passport_issue_date.year,
      passport_expiry_date:
        data.passport_expiry_date == null
          ? ""
          : data.passport_expiry_date.day +
            "/" +
            data.passport_expiry_date.month +
            "/" +
            data.passport_expiry_date.year,
      child_information: data.child_information,
      have_been_in_14_days: data.have_been_in_14_days,
      arrival_date:
        data.arrival_date == null
          ? ""
          : data.arrival_date.day +
            "/" +
            data.arrival_date.month +
            "/" +
            data.arrival_date.year,
      purpose_of_visit: data.purpose_of_visit,
      purpose_description: data.purpose_description,
      port_of_departure: data.port_of_departure,
      airline_vessel: data.airline_vessel,
      Flight_vessel_no: data.Flight_vessel_no,
      address1: data.address1,
      address2: data.address2,
      city: data.city,
      state: data.state,
      postal_code: data.postal_code,
      country: data.country,
      address_in_srilanka: data.sl_address,
      telephone_no: data.telephone_no,
      mobile_no: data.mobile_no,
      fax_no: data.fax_no,
      email: data.email,
      passport_path: passport_path,
      dec_valid_residence_visa: data.dec_valid_residence_visa,
      dec_multiple_entry_visa: data.dec_multiple_entry_visa,
      dec_valid_eta_extension: data.dec_valid_eta_extension,
      website_url: website_url,
      ip_address: ip_address,
      browser: BrowserDetails,
      sl_application_main_child: [ChilddataSource],
    };
  }
  createRequestBusinessIndividual(
    data,
    temporary_id,
    website_url,
    ChilddataSource,
    passport_path,
    ip_address,
    BrowserDetails
  ) {
    // format data as per backend requirement
    return {
      temporary_id: temporary_id == null ? "" : temporary_id,
      application_type: "Business Individual",
      visa_type:
        "Normal Processing (Visa Delivery Time 24 to 48 Business Hours)", //data.visa_type,
      surname_family_name: data.surname_family_name,
      other_given_name: data.other_given_name,
      title: data.title,
      dob:
        data.dob == null
          ? ""
          : data.dob.day + "/" + data.dob.month + "/" + data.dob.year,
      gender: data.gender,
      nationality: data.nationality,
      isVaccinated: data.isVaccinated,
      country_of_birth: data.country_of_birth,
      occupation: data.occupation,
      passport_no: data.passport_no,
      passport_issue_date:
        data.passport_issue_date == null
          ? ""
          : data.passport_issue_date.day +
            "/" +
            data.passport_issue_date.month +
            "/" +
            data.passport_issue_date.year,
      passport_expiry_date:
        data.passport_expiry_date == null
          ? ""
          : data.passport_expiry_date.day +
            "/" +
            data.passport_expiry_date.month +
            "/" +
            data.passport_expiry_date.year,
      child_information: data.child_information,
      have_been_in_14_days: data.have_been_in_14_days,
      arrival_date:
        data.arrival_date == null
          ? ""
          : data.arrival_date.day +
            "/" +
            data.arrival_date.month +
            "/" +
            data.arrival_date.year,
      purpose_of_visit: data.purpose_of_visit,
      purpose_description: data.purpose_description,
      port_of_departure: data.port_of_departure,
      airline_vessel: data.airline_vessel,
      Flight_vessel_no: data.Flight_vessel_no,
      company_name: data.company_name,
      address1: data.address1,
      address2: data.address2,
      city: data.city,
      state: data.state,
      postal_code: data.postal_code,
      country: data.country,
      telephone_no: data.telephone_no,
      mobile_no: data.mobile_no,
      fax_no: data.fax_no,
      email: data.email,
      sl_company_name: data.sl_company_name,
      sl_address1: data.sl_address1,
      sl_address2: data.sl_address2,
      sl_city: data.sl_city,
      sl_state: data.sl_state,
      sl_postal_code: data.sl_postal_code,
      sl_telephone_no: data.sl_telephone_no,
      sl_mobile_no: data.sl_mobile_no,
      sl_fax_no: data.sl_fax_no,
      sl_email: data.sl_email,
      passport_path: passport_path,
      dec_valid_residence_visa: data.dec_valid_residence_visa,
      dec_multiple_entry_visa: data.dec_multiple_entry_visa,
      dec_valid_eta_extension: data.dec_valid_eta_extension,
      website_url: website_url,
      ip_address: ip_address,
      browser: BrowserDetails,
      sl_application_main_child: [ChilddataSource],
    };
  }
  createRequestForcheckpartialy(data) {
    // format data as per backend requirement
    return {
      // api_secrets: { api_id: apiId.api_id, api_key: secretData.api_key },
      temporary_id: data.temporary_id,
    };
  }
}



// WEBPACK FOOTER //
// C:/Users/user/Desktop/rohini_india/angular/Srilanka-eta.org.lk/src/app/shared/services/application.service.ts